import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { ApiError, notifyError } from './client';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { manualError?: boolean };
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err, query) => {
      // Ошибку первой загрузки показывает страница; уведомляем только о сбое фонового обновления.
      if (err instanceof ApiError && err.status === 404) return;
      if (query.state.data === undefined) return;
      notifyError(err);
    },
  }),
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      if (mutation.meta?.manualError) return;
      notifyError(err);
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
    mutations: { retry: false },
  },
});
